import script from "./ModalCopy.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalCopy.vue?vue&type=script&setup=true&lang=js"

import "./ModalCopy.vue?vue&type=style&index=0&id=fc35efa8&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Smart2Docs_Front-end/Smart2Docs_Front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc35efa8"]])

export default __exports__